const CONSTANTS = {
  VIEWS: {
    MY_TEAM: 'My Team',
    ALL_MEMBERS: 'All Members',
    UNASSIGNED: 'Unassigned'
  }
};

export default CONSTANTS;
